export const servicesConstants = {
  SERVICES_SET_SUBMENU: 'SERVICES_SET_SUBMENU',
};